import envVariables from "src/lib/envVariables";
import { isAndroidDevice, isIOSDevice } from "src/lib/platform";

const PERSONIFY_SSO_START_PATH = "/v1/integrations/personify/sso/start";

/**
 * The backend's `/sso/start` is the only entry point into Personify's OIDC flow
 * (BACK-5919) — it redirects the member to Personify, then back through our own
 * `/sso/callback` with a single-use exchange token, so "continue" here means a
 * full browser navigation to our own API host, not Personify's.
 *
 * The target follows the device, not the Capacitor platform: a phone browser
 * also gets the app-link handover (`/auth/ott-app`), so the OS opens the app
 * when it is installed and the same route finishes the login on web when not.
 */
export const getContinueWithPersonifyTargetUrl = (): string => {
  const target = isIOSDevice() ? "IOS" : isAndroidDevice() ? "ANDROID" : "WEB";
  return `${envVariables.API_BASE_URL}${PERSONIFY_SSO_START_PATH}?target=${target}`;
};
